<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @auth-user="authUser"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <AuthUser
      :visible.sync="authUserOpts.visible"
      :roleID="authUserOpts.roleID"
    />
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import AuthUser from '../auth-user'
export default {
  components: { PageHeader, PageMain, AuthUser },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      authUserOpts: { roleID: '', visible: false },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sysRoleListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    authUser({ roleID }) {
      this.authUserOpts = { roleID, visible: true }
    },
  },
}
</script>
